// extracted by mini-css-extract-plugin
module.exports = {"button":"GameOver_button__33OVA"};